import { useState, useEffect, type ImgHTMLAttributes, type ReactNode } from 'react';
import { portfolioApi } from '../api/portfolioApi';

interface ThumbImgProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  url: string | null;
  fallback?: ReactNode;
}

/** sv-photo 이미지가 로그인 토큰 필요 — apiClient(JWT)로 blob 받아 objectURL 표시(인디포토 ThumbImg과 동일). */
// alt 기본값 "" — 카드 커버·사진 그리드는 제목 텍스트가 곁에 있는 장식 이미지다. 의미 이미지면 호출부에서 alt 를 넘긴다.
export function ThumbImg({ url, fallback = null, style, alt = '', ...imgProps }: ThumbImgProps) {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!url) {
      setBlobUrl(null);
      return;
    }
    const controller = new AbortController();
    let objectUrl: string | null = null;
    setLoaded(false);
    portfolioApi
      .getThumb(url, controller.signal)
      .then((res) => {
        objectUrl = URL.createObjectURL(res.data);
        setBlobUrl(objectUrl);
      })
      .catch(() => {
        /* 실패(401·404·abort 포함) 시 fallback 유지 */
      });
    return () => {
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  if (!blobUrl) return <>{fallback}</>;
  return (
    <img
      src={blobUrl}
      alt={alt}
      onLoad={() => setLoaded(true)}
      style={{ ...style, opacity: loaded ? 1 : 0, transition: 'opacity .2s ease' }}
      {...imgProps}
    />
  );
}
